import { Col } from "react-bootstrap";
import { useLocale } from "@/hooks/useLocale";
import { MiniTabs } from "@/ui/MiniTabs";
import { SeriousAboutTalent } from "@/ui/SeriousAboutTalent";

export const CulturePageValueSection = ({ className }) => {
  const locale = useLocale();

  return (
    <SeriousAboutTalent
      className={className}
      title={`page.culture.value.title.${locale}`}
      text={`page.culture.value.text.${locale}`}
      variant="tertiary"
      titleClassName="h5"
      lg={4}
    >
      <Col xs={12} lg={8}>
        <MiniTabs
          className="mt-lg-5 pt-lg-5"
          items={[
            {
              title: { path: `page.culture.value.tabs.1.title.${locale}` },
              text: { path: `page.culture.value.tabs.1.text.${locale}` },
            },
            {
              title: { path: `page.culture.value.tabs.2.title.${locale}` },
              text: { path: `page.culture.value.tabs.2.text.${locale}` },
            },
          ]}
          variant="secondary"
        />
      </Col>
    </SeriousAboutTalent>
  );
};

CulturePageValueSection.defaultProps = {
  className: "pb-4",
};
